export default __webpack_public_path__ + "static/media/3_hitrate.7e1cbd75.csv";